import { useSuspenseQuery } from '@apollo/client';

import { useExperiment } from '@xing-com/hub';

import { BestCompaniesByCityDocument } from '../../graphql/queries/best-companies-by-city.gql-types';

type UseBestCompaniesByCityProps = {
  city: string;
  offset?: number;
  limit?: number;
};

export const useBestCompaniesByCity = ({
  city,
  offset = 0,
  limit = 5,
}: UseBestCompaniesByCityProps) => {
  const response = useSuspenseQuery(BestCompaniesByCityDocument, {
    variables: {
      cityId: city,
      offset,
      limit,
      shouldHideKununuData: useExperiment('ABACUS-518') === 'B',
    },
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
  });

  return response;
};
